import React from "react";
import { DataRequestDetail } from "../../../../../common/models";
import { ProfilingOptOutStep } from "./auto-profiling/ProfilingOptOutStep";
import { NotifyConsumer } from "./shared/NotifyConsumer";
import { VerifyConsumer } from "./shared/VerifyConsumer";

type Props = {
  request: DataRequestDetail;
};

export const RequestToProfilingOptOutSteps: React.FC<Props> = ({ request }) => {
  switch (request.state) {
    case "VERIFY_CONSUMER":
      return <VerifyConsumer />;
    case "STOP_AUTO_PROFILING":
      return <ProfilingOptOutStep />;
    case "NOTIFY_CONSUMER":
      return <NotifyConsumer />;
  }
  return null;
};
